(function() {
  const whenSwiperReady = (callback) => {
    if (typeof window.Swiper === 'function') {
      callback();
      return;
    }

    const onReady = () => {
      clearInterval(timer);
      callback();
    };
    const timer = setInterval(() => {
      if (typeof window.Swiper === 'function') {
        window.removeEventListener('layer:swiper-ready', onReady);
        onReady();
      }
    }, 250);
    window.addEventListener('layer:swiper-ready', onReady, { once: true });
  };

  const calcTop = (section) => {
    const imageWrapper = section.querySelector('.article-card__image-wrapper');
    let top = 0;

    if (imageWrapper) {
      top = imageWrapper.offsetHeight / 2;
    } else {
      top = 50;
    }

    return top;
  }

  let swiperInstances = [];
  let waitingForSwiper = false;

  const initSlider = () => {
    if (typeof window.Swiper !== 'function') {
      if (waitingForSwiper) return;
      waitingForSwiper = true;
      whenSwiperReady(() => {
        waitingForSwiper = false;
        initSlider();
      });
      return;
    }

    const sliders = document.querySelectorAll('.blog__slider');
    const isMobile = window.innerWidth < 750;

    // Destroy existing swipers
    swiperInstances.forEach(swiper => {
      if (swiper && swiper.destroy) {
        swiper.destroy(true, true);
      }
    });
    swiperInstances = [];

    sliders.forEach((slider, index) => {
      const isGridLayout = slider.classList.contains('blog__posts--grid');

      // Grid layout: only initialize swiper on mobile
      if (isGridLayout && !isMobile) {
        // Don't initialize swiper for grid layout on desktop - CSS will handle grid display
        return;
      }

      const swiperConfig = {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: isMobile ? 0 : 16,
        speed: 500,
        navigation: {
          nextEl: slider.querySelector('.blog__slider-nav .swiper-button-next'),
          prevEl: slider.querySelector('.blog__slider-nav .swiper-button-prev'),
        },
      };

      // Mobile: fade effect for in-place transition
      if (isMobile) {
        swiperConfig.effect = 'fade';
        swiperConfig.fadeEffect = { crossFade: true };
      } else {
        // Desktop: normal slide with breakpoints (for column layout only)
        swiperConfig.breakpoints = {
          576: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          990: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 8,
          },
          1200: {
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: 8,
          }
        };
      }

      const articlesSlider = new Swiper(slider, swiperConfig);
      swiperInstances.push(articlesSlider);
    });
  }

  // Debounced resize handler
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initSlider();
    }, 250);
  }

  const initSection = () => {
    const sections = document.querySelectorAll('.section-featured-blog');

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      sections.forEach(section => {
        let top = calcTop(section);
        if (section.querySelector('.blog__slider-nav'))
          section.querySelector('.blog__slider-nav').style.top = top + 'px';
      });
    });

    sections.forEach(section => {
      sectionResizeObserver.observe(section);
    });

    initSlider();

    // Listen for resize to reinitialize slider with correct effect
    window.addEventListener('resize', handleResize);
  }

  initSection();

  document.addEventListener('shopify:section:load', function () {
    initSection();
  });
})();
